import type {SearchState} from '../../context/SearchContext';

export function flattenFacets(activeFacets: Record<string, string[]>): string[] | undefined {
  const flat = Object.values(activeFacets).flat();
  return flat.length > 0 ? flat : undefined;
}

export function buildSearchQueryKey(state: SearchState) {
  return {
    keywords: state.query || undefined,
    department_id: state.departmentId,
    sort_option_id: state.sortOptionId,
    facets: flattenFacets(state.activeFacets),
    specials: state.specials || undefined,
    sell_price_cents: state.priceRange
      ? {minimum: state.priceRange.min * 100, maximum: state.priceRange.max * 100}
      : undefined,
  };
}

export const searchKeys = {
  all: ['search'] as const,
  store: (storeId: string | null) => [...searchKeys.all, storeId] as const,
  lines: (storeId: string | null, params: ReturnType<typeof buildSearchQueryKey>) =>
    [...searchKeys.store(storeId), 'lines', params] as const,
  facetGroups: (
    storeId: string | null,
    params: Pick<ReturnType<typeof buildSearchQueryKey>, 'department_id' | 'keywords' | 'specials'>,
  ) => [...searchKeys.store(storeId), 'facet-groups', params] as const,
  sortOptions: () => [...searchKeys.all, 'sort-options'] as const,
};
